// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__2nb7P","buttons":"PendingPaymentAlert_buttons__1EB0z"};